import { render, staticRenderFns } from "./Shuguo.vue?vue&type=template&id=4fba84b0&scoped=true"
var script = {}
import style0 from "./Shuguo.vue?vue&type=style&index=0&id=4fba84b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fba84b0",
  null
  
)

export default component.exports